import {
  Component,
  computed,
  forwardRef,
  input,
  signal,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

let nextFormToggleId = 0;

@Component({
  selector: 'app-form-toggle',
  standalone: true,
  imports: [],
  templateUrl: './form-toggle.component.html',
  styleUrl: './form-toggle.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormToggleComponent),
      multi: true,
    },
  ],
})
export class FormToggleComponent implements ControlValueAccessor {
  readonly label = input<string>('');
  readonly testId = input<string>('form-toggle');
  readonly disabled = input(false);

  private readonly controlId = `form-toggle-${++nextFormToggleId}`;
  private readonly disabledFromControl = signal(false);
  private readonly checked = signal(false);

  private onChange: (value: boolean) => void = () => undefined;
  private onTouched: () => void = () => undefined;

  readonly labelId = `${this.controlId}-label`;
  readonly switchId = `${this.controlId}-switch`;

  readonly isDisabled = computed(() => this.disabled() || this.disabledFromControl());
  readonly isChecked = computed(() => this.checked());

  writeValue(value: boolean | null): void {
    this.checked.set(!!value);
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabledFromControl.set(isDisabled);
  }

  onSwitchClick(): void {
    if (this.isDisabled()) {
      return;
    }

    const next = !this.checked();
    this.checked.set(next);
    this.onChange(next);
    this.onTouched();
  }
}
